/**
 * @generated SignedSource<<b2f1fc6fa37bb196e20390c618780c71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Payment_pixQrCode$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentQrCode_pixQrCode">;
  readonly " $fragmentType": "Payment_pixQrCode";
};
export type Payment_pixQrCode$key = {
  readonly " $data"?: Payment_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"Payment_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Payment_pixQrCode",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentQrCode_pixQrCode"
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "551cede6283c328bbbd6b26e51520372";

export default node;
